import QueryString from 'query-string';
import { routeToSpecificScope } from '../../helpers/helpersts';
import * as TYPE from '../types';
import { SERVER } from '../../config/server.config';
import { request } from '../../config/services/datasets';
// import healthSummary from "../../dummie/healthSummary";
// import healthSensors from "../../dummie/healthSensors";
// import healthEntity from "../../dummie/healthEntity";
// import healthDPackets from "../../dummie/healthDPackets";
// import healthPlot from '../../dummie/healthPlot';
import { addLoadingFlag, changeMessageLoading, subLoadingFlag } from './loading';
import { CUSTOM, FILTER_KEYS, MESSAGES } from '../../config/constants';
import { isHealthScopeChecker } from '../../helpers/helpers';

export const replaceSummaryData = summary => {
  return {
    type: TYPE.REPLACE_SUMMARY_DATA,
    summary
  };
};

export const replaceSensorsData = sensors => {
  return {
    type: TYPE.REPLACE_SENSORS_DATA,
    sensors
  };
};

export const replaceEntityData = entity => {
  return {
    type: TYPE.REPLACE_ENTITY_DATA,
    entity
  };
};

export const replaceDPacketsData = dPackets => {
  return {
    type: TYPE.REPLACE_D_PACKET_DATA,
    dPackets
  };
};

export const getSummaryHealthData = (siteId, withLoader) => {
  return async (dispatch, getState) => {
    if (withLoader) {
      dispatch(addLoadingFlag('HEALTH_SUMMARY'));
    }
    dispatch(replaceSummaryData({}));

    const path = getState().router.location.pathname;
    const specificScope = routeToSpecificScope(path);
    const params = getState().filters[specificScope] ? JSON.parse(JSON.stringify(getState().filters[specificScope])) : {};
    const paramsToFetch = { 'api-call': 'summary' };
    if (params[FILTER_KEYS.TIME_SLIDER] && params[FILTER_KEYS.TIME_SLIDER].status === CUSTOM) {
      paramsToFetch.time = params[FILTER_KEYS.TIME_SLIDER].selectedTime / 1000;
    }
    const results = await request(SERVER.HEALTH_VENUE_PROXY(siteId) +
      '?' +
      QueryString.stringify(paramsToFetch, { arrayFormat: 'comma', encode: false }));

    if (results && results.summary) {
      dispatch(replaceSummaryData(results.summary));
      if (Object.keys(results.summary).length === 0) {
        dispatch(changeMessageLoading('HEALTH_SUMMARY', MESSAGES.EMPTY));
      } else {
        dispatch(changeMessageLoading('HEALTH_SUMMARY', null));
      }
    } else if (getState().loading['HEALTH_SUMMARY'].count > 0) {
      dispatch(changeMessageLoading('HEALTH_SUMMARY', MESSAGES.EMPTY));
    }
    if (withLoader) {
      dispatch(subLoadingFlag('HEALTH_SUMMARY'));
    }
  };
};

export const getSensorsHealthData = (siteId, withLoader) => {
  return async (dispatch, getState) => {
    if (withLoader) {
      dispatch(addLoadingFlag('HEALTH_SENSORS'));
    }
    dispatch(replaceSensorsData([]));

    const path = getState().router.location.pathname;
    const specificScope = routeToSpecificScope(path);
    const params = getState().filters[specificScope] ? JSON.parse(JSON.stringify(getState().filters[specificScope])) : {};
    const paramsToFetch = { 'api-call': 'sensors' };
    if (params[FILTER_KEYS.TIME_SLIDER] && params[FILTER_KEYS.TIME_SLIDER].status === CUSTOM) {
      paramsToFetch.time = params[FILTER_KEYS.TIME_SLIDER].selectedTime / 1000;
    }
    const results = await request(SERVER.HEALTH_VENUE_PROXY(siteId) +
      '?' +
      QueryString.stringify(paramsToFetch, { arrayFormat: 'comma', encode: false }));

    if (results && results.sensorinfo) {
      dispatch(replaceSensorsData(results.sensorinfo));
      if (results.sensorinfo.length === 0) {
        dispatch(changeMessageLoading('HEALTH_SENSORS', MESSAGES.EMPTY));
      } else {
        dispatch(changeMessageLoading('HEALTH_SENSORS', null));
      }
    } else if (getState().loading['HEALTH_SENSORS'].count > 0) {
      dispatch(changeMessageLoading('HEALTH_SENSORS', MESSAGES.EMPTY));
    }
    if (withLoader) {
      dispatch(subLoadingFlag('HEALTH_SENSORS'));
    }
  };
};

export const getEntityData = (siteId, withLoader) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    if (withLoader) {
      dispatch(addLoadingFlag(scope));
    }

    const specificScope = routeToSpecificScope(path);
    const params = getState().filters[specificScope] ? JSON.parse(JSON.stringify(getState().filters[specificScope])) : {};
    const paramsToFetch = { 'api-call': 'taginfo' };
    if (params[FILTER_KEYS.TIME_SLIDER] && params[FILTER_KEYS.TIME_SLIDER].status === CUSTOM) {
      paramsToFetch.time = params[FILTER_KEYS.TIME_SLIDER].selectedTime / 1000;
    }
    const results = await request(SERVER.HEALTH_VENUE_PROXY(siteId) +
      '?' +
      QueryString.stringify(paramsToFetch, { arrayFormat: 'comma', encode: false }));

    if (results && results.taginfo) {
      dispatch(replaceEntityData(results.taginfo));
      if (results.taginfo.length === 0) {
        dispatch(changeMessageLoading(scope, MESSAGES.NO_ENTITIES_HEALTH));
      } else {
        dispatch(changeMessageLoading(scope, null));
      }
    } else if (isHealthScopeChecker(scope)) {
      dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
    }
    if (withLoader) {
      dispatch(subLoadingFlag(scope));
    }
  };
};

export const getDPacketsData = (siteId, withLoader) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    if (withLoader) {
      dispatch(addLoadingFlag(scope));
    }

    const paramsToFetch = { 'api-call': 'dpackets' };
    const results = await request(SERVER.HEALTH_VENUE_PROXY(siteId) +
      '?' +
      QueryString.stringify(paramsToFetch, { arrayFormat: 'comma', encode: false }));

    if (results && results.dpackets) {
      dispatch(replaceDPacketsData(results.dpackets));
      dispatch(changeMessageLoading(scope, null));
    } else {
      dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
    }
    if (withLoader) {
      dispatch(subLoadingFlag(scope));
    }
  };
};

export const packetGraph = data => {
  return {
    type: TYPE.REPLACE_PACKET_GRAPH,
    data: data
  };
};

export const getPacketGraph = (siteId, withLoader) => {
  return async (dispatch, getState) => {
    if (withLoader) {
      dispatch(addLoadingFlag('HEALTH_PACKET_GRAPH'));
    }
    const path = getState().router.location.pathname;
    const specificScope = routeToSpecificScope(path);
    const params = getState().filters[specificScope] ? JSON.parse(JSON.stringify(getState().filters[specificScope])) : {};
    const paramsToFetch = { 'api-call': 'plot' };
    if (params[FILTER_KEYS.TIME_SLIDER] && params[FILTER_KEYS.TIME_SLIDER].status === CUSTOM) {
      paramsToFetch.start = params[FILTER_KEYS.TIME_SLIDER].rangeTimeStart / 1000;
      paramsToFetch.stop = params[FILTER_KEYS.TIME_SLIDER].selectedTime / 1000;
    }
    const results = await request(SERVER.HEALTH_VENUE_PROXY(siteId) +
      '?' +
      QueryString.stringify(paramsToFetch, { arrayFormat: 'comma', encode: false }));
    if (results && results.plot) {
      dispatch(packetGraph(results.plot));
      dispatch(changeMessageLoading('HEALTH_PACKET_GRAPH', null));
    }
    if (withLoader) {
      dispatch(subLoadingFlag('HEALTH_PACKET_GRAPH'));
    }
  };
};


export const changeMessageNoData = () => {
  return dispatch => {
    dispatch(changeMessageLoading('HEALTH_PACKET_GRAPH', null));
    dispatch(changeMessageLoading('HEALTH_SENSORS', MESSAGES.EMPTY));
    dispatch(changeMessageLoading('HEALTH_SUMMARY', MESSAGES.EMPTY));

    dispatch(packetGraph([{}]));
    dispatch(replaceSensorsData([]));
    dispatch(replaceSummaryData({}));
  };
};

export const changeMessageNoDaGeneric = () => {
  return (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
  };
};
